import { useState } from 'react';

import { Elements } from '@stripe/react-stripe-js';

import { ExpressAsApmPaymentWrapper } from './ExpressAsAPM';
import { StripeCardContainer } from './StripeCardContainer';
import { useCheckout } from '../../../../hooks/use-checkout';
import { StripePaymentElement } from './StripePaymentElement';
import { usePaymentState } from '../../hooks/use-payment-state';
import { useStripeConfig } from '../../hooks/use-stripe-config';
import { EBEPaymentMethodsName, EPaymentProvider } from '../../../../contracts';

interface StripePaymentWrapperProps {
  setOverlay: (value: boolean) => void;
  setApmTab: (value: any) => void;
}

export function StripePaymentWrapper(props: StripePaymentWrapperProps) {
  const savedCards = usePaymentState((state) => state.savedCards);
  const hasSavedCards = Boolean(
    savedCards.filter((card) => card.paymentProvider === EPaymentProvider.stripe).length
  );
  const [savedCardFlow, setSavedCardFlow] = useState({
    show: hasSavedCards,
    defaultSavedCardChecked: false,
  });
  const { selectedPaymentMethod, checkoutData } = useCheckout();
  const { paymentElementPromise, paymentElementProviderKey, paymentElementOptions } =
    useStripeConfig();
  const isCard = selectedPaymentMethod?.paymentMethodName === EBEPaymentMethodsName.card;
  const isNewSavedCardFlow = !checkoutData?.checkoutConfigurations?.showLinkSavedCard && isCard;
  const isExpressAsApm =
    selectedPaymentMethod?.paymentMethodName === EBEPaymentMethodsName.link ||
    selectedPaymentMethod?.paymentMethodName === EBEPaymentMethodsName.google;

  if (isExpressAsApm) {
    return (
      <ExpressAsApmPaymentWrapper
        paymentMethodName={selectedPaymentMethod?.paymentMethodName as EBEPaymentMethodsName}
      />
    );
  }

  return (
    <Elements
      stripe={paymentElementPromise}
      key={paymentElementProviderKey}
      options={paymentElementOptions}
    >
      {isNewSavedCardFlow && savedCardFlow.show ? (
        <StripeCardContainer onCardFlowChange={setSavedCardFlow} />
      ) : (
        <StripePaymentElement
          {...props}
          savedCardProps={{
            showBackButton: hasSavedCards && isNewSavedCardFlow,
            onBackButtonClicked: () =>
              setSavedCardFlow({ show: true, defaultSavedCardChecked: false }),
          }}
        />
      )}
    </Elements>
  );
}
